import styled from "styled-components";

const LinkRow = styled.div.attrs({
  className: "links links__row",
  role: "menubar"
})`
  .list-container {
    position: relative;
  }
`;

export default LinkRow;
